import axios from "axios";
import constants from "../constants/constants";

const {
  GET_PRODUCTS, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_ERROR,
  SELECT_PRODUCT, SELECT_PRODUCT_SUCCESS, SELECT_PRODUCT_ERROR,
  GET_SELECTED_PRODUCTS, GET_SELECTED_PRODUCTS_SUCCESS, GET_SELECTED_PRODUCTS_ERROR
} = constants;

const GET_PRODUCTS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/getProducts";
const SELECT_PRODUCT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/selectProduct";
const GET_SELECTED_PRODUCTS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/getSelectedProducts";

export const getProductsAction = (config) => async (dispatch) => {
  dispatch({ type: GET_PRODUCTS })
  await axios.get(GET_PRODUCTS_API_END_POINT, config)
    .then((res) => dispatch({ type: GET_PRODUCTS_SUCCESS, products: res?.data?.products }))
    .catch((error) => dispatch({ type: GET_PRODUCTS_ERROR, error }))
}

export const selectProductAction = (config, data, callback1, callback2, callback3) => async (dispatch) => {
  dispatch({ type: SELECT_PRODUCT })
  await axios.post(SELECT_PRODUCT_API_END_POINT, data, config)
    .then((res) => {
      const { message, user } = res.data;
      dispatch({ type: SELECT_PRODUCT_SUCCESS, message })
      callback1?.();
      callback2?.();
      callback3?.();
    })
    .catch((error) => dispatch({ type: SELECT_PRODUCT_ERROR, error }))
}

export const getSelectedProductsAction = (config, data) => async (dispatch) => {
  dispatch({ type: GET_SELECTED_PRODUCTS })
  await axios.get(GET_SELECTED_PRODUCTS_API_END_POINT, config)
    .then((res) => {
      const { selectedProducts } = res.data;
      dispatch({ type: GET_SELECTED_PRODUCTS_SUCCESS, selectedProducts })
    })
    .catch((error) => dispatch({ type: GET_SELECTED_PRODUCTS_ERROR, error }))
}

